class LocationAutocompletes
  jQuery ->
      $('#location_name_text').autocomplete
          source: $('#location_name_text').data('autocomplete-source'),
          select: (event, ui) ->
            $.ajax(
              type: 'get',
              url: "/answering_service/update_latches_options?trouble_ticket_location_id=#{ui.item.value_for}&trouble_ticket_rental_id=#{$("#trouble_ticket_rental_id").val()}&trouble_ticket_rental_type=#{$("#rental_type").val()}"
              success: ->
                if $('#location_name_text').val() == "-clr-"
                  $('#location_name_text').val("")
                  $('#trouble_ticket_location_id').val("")
                else
                  $('#location_name_text').val(ui.item.label)
                  $('#trouble_ticket_location_id').val(ui.item.value_for)
            )

      $.ui.autocomplete.prototype._renderItem = (ul, item) ->
        t = if @term.trim() == ""
              item.value
            else
              String(item.value).replace(new RegExp(@term, "gi"),"<strong>$&</strong>")
        $("<li></li>")
          .data("item.autocomplete", item)
          .append("<div>" + t + "</div>")
          .appendTo(ul)

      $('#all_locations').click ->
        $('#location_name_text').autocomplete("search", " ")

      $('#filter_by_location').autocomplete
          source: $('#filter_by_location').data('autocomplete-source'),
          select: (event, ui) ->
            $.ajax(
              type: 'get',
              url: '/g7_spaces'
              success: ->
                $('#filter_by_location').val(ui.item.label)
            )

module.exports = LocationAutocompletes
